(function() {
	'use strict';

	angular
		.module('pwc.controllers')
		.controller('WineBaseAddEditController', WineBaseAddEditController);

	WineBaseAddEditController.$inject = ['$scope', '$rootScope', '$mdToast', '$mdDialog', 'userPouch', '$state', '$window', 'lodash', 'Wine', 'WineRepository', 'AgingPotential', 'systemPouch', '$log', '$q', '$mdBottomSheet', 'WineTable', 'BarcodeFactory', '$timeout', 'DialogService', 'Rollbar', 'UserService', '$filter', 'Utils', 'API', 'PwcRepository', 'UserStore'];

	function WineBaseAddEditController($scope, $rootScope, $mdToast, $mdDialog, userPouch, $state, $window, lodash, Wine, WineRepository, AgingPotential, systemPouch, $log, $q, $mdBottomSheet, WineTable, BarcodeFactory, $timeout, DialogService, Rollbar, UserService, $filter, Utils, API, PwcRepository, UserStore){

		/* jshint validthis: true */
		var self = this;

		self.userStore = UserStore;

		self.status = {
			handlingPrompt: false
		};

		// parameters which can be passed into the route / url
		self.params = {
			id: $state.params.id ? $state.params.id.toString() : null,
			tab: $state.params.tab
		};

		self.original = {};

		self.thumbnail = null;

		self.error = null;

		self.wine = {};

		// field for new document upload
		self.doc = null;

		// index of the current wine in relation to the active wine list
		self.wineIndex = null;

		self.combinedHistory = [];

		self.drinkHistory = [];

		self.bodyInput = {
			"query": null,
			"options": [
				{
					value: "Light",
					display: "Light"
				},
				{
					value: "Medium",
					display: "Medium"
				},
				{
					value: "Full",
					display: "Full"
				}
			],
			"search": bodyInputSearch
		};

		self.grapeSelected = null;

		self.grapeQuery = null;

		self.grapes = [];

		self.search = {
			"body": null,
			"distinction": null
		};

		self.selectedTab = 0;
		self.selectedFooter = 0;
		self.categories = [];
		self.varietals = [];
		self.customFields = [];
		self.wineNames = [];
        self.producerNames = [];
        self.regionData = [];
        self.bottleSizes = [];

		self.fields = null;

		self.purchase = purchase;
		self.grapeSearch = grapeSearch;
		self.grapeWasSelected = grapeWasSelected;
		self.showAlert = showAlert;
		self.distinctionChange = distinctionChange;
		self.updateTotalValue = updateTotalValue;
		self.toast = toast;
		self.save = save;
		self.canRemove = canRemove;
		self.revert = revert;
		self.removeHistory = removeHistory;
		self.confirmDelete = confirmDelete;
		self.openAgingPotential = openAgingPotential;
		self.convertToGrape = convertToGrape;
		self.resizeAndUploadImage = resizeAndUploadImage;
		self.openFooterActions = openFooterActions;
		self.closeBottomSheet = closeBottomSheet;
		self.markAllOnOrderAsArrived = markAllOnOrderAsArrived;
		self.confirmRemoveHistory = confirmRemoveHistory;
		self.searchWineSearcher = searchWineSearcher;
		self.toggleFavorite = toggleFavorite;
		self.subtract = subtract;
		self.submitForm = submitForm;
		self.nextWine = nextWine;
		self.prevWine = prevWine;
		self.hasNext = hasNext;
		self.hasPrev = hasPrev;
		self.generateBarcode = generateBarcode;
		self.selectChip = selectChip;
		self.chooseLabel = chooseLabel;
		self.editTransaction = editTransaction;
		self.duplicate = duplicate;
		self.nameSearch = nameSearch;
		self.shouldShowField = shouldShowField;
		self.goBack = Utils.goBack;
		self.openDoc = openDoc;
		self.removeDoc = removeDoc;
		self.markDirty = markDirty;
		self.producerSearch = producerSearch;
		self.regionSearch = regionSearch;
		self.selectedRegion = selectedRegion;
		self.varietalSearch = varietalSearch;
		self.distinctionSearch = distinctionSearch;
        self.selectedDistinction = selectedDistinction;
        self.categorySearch = categorySearch;
        self.selectedType = selectedType;
        self.grapeText = grapeText;
        self.bottleSizeSearch = bottleSizeSearch;
        self.cleanRegion = cleanRegion;
        self.validateDistinction = validateDistinction;

		/** initialize */

		initialize();

		/** begin methods */

		function initialize(){

			UserService.getSetting('fields', {}).then(function(data){
				self.fields = data;
			});

			systemPouch.findAllGrapes().then(function(data){
				self.grapes = data;
			});

			systemPouch.fetch('category').then(function(data){
				self.categories = data;
			});

			systemPouch.fetch('distinction').then(function(data){
				self.distinctions = data;
			});

			systemPouch.fetch('varietal').then(function(data){
				self.varietals = data;
			});

            systemPouch.fetch('bottle').then(function (data) {
                self.bottleSizes = data;
            });

			// set other data for autocomplete
            _loadProducerNames();
            _loadWineNames();
            _loadRegionData();

			var recordChangeListener = $rootScope.$on('WineRecordWasChanged', function(){
				showWine();
			});

			if (lodash.isNotEmptyOrNull(self.params.id)){

				showWine();

				if (! lodash.isEmpty(userPouch.getSyncHandler())) {
					$log.debug('Setting up change handler to listen for updates to this wine from remote.');
					userPouch.getSyncHandler().on('change', onChange);
				}

				if (lodash.isNotEmptyOrNull(self.params.tab)){
					self.selectedTab = self.params.tab;
				}

				updateWineIndex();

			} else {
				self.wine = new Wine();
				generateId();
				registerWatchers();
			}

			// Prevent nav away if pending - only on edits
			var stateChangeListener = $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams){

				if (self.status.handlingPrompt){
					return;
				}

				if (UserStore.state.hasPendingChanges){

					event.preventDefault();

					promptSave(lodash.get(toState, 'data.title'), toState.name, toParams);
				}

				return;
			});

			var transactionAddedListener = $rootScope.$on('WineTransactionAddedButNotSaved', markDirty);

			$scope.$on('$destroy', stateChangeListener);

			$scope.$on('$destroy', recordChangeListener);

			$scope.$on('$destroy', transactionAddedListener);
		}

		function markDirty(){
			$log.debug('Marking form as dirty...');
            UserStore.state.hasPendingChanges = true;
            $scope.form.$setDirty();
		}

		function promptSave(stateName, stateRoute, params){
			$mdDialog.show({
				controller: 'PromptSaveDialogController as dialog',
				templateUrl: 'templates/dialogs/prompt-save.html',
				locals: {
					stateName: stateName
				}
			}).then(function(shouldSave) {

				self.status.handlingPrompt = true;

				changeState(stateRoute, params, shouldSave);

			}, function() {
				// closed, do nothing
				self.status.handlingPrompt = false;
			});
		}

		function changeState(stateName, params, shouldSave){
			if (shouldSave){
				save(null, false, stateName, params);
			} else {
				Utils.go(stateName, params);
			}
		}

		function registerWatchers(){

			$scope.$watch(function() {
				return self.wine;
			}, function watchWine(newValue, oldValue) {
				if (newValue != oldValue){

					UserStore.state.hasPendingChanges = $scope.form.$dirty && ! angular.equals(self.original, self.wine);

					if (newValue.name != oldValue.name){
						nameChange();
					}

					if (lodash.get(newValue, 'varietal._id') !== lodash.get(oldValue, 'varietal._id')){
						varietalChange();
					}

					if (lodash.get(newValue, 'distinction._id') !== lodash.get(oldValue, 'distinction._id')){
						distinctionChange(true);
					}

					if (! angular.equals(lodash.get(newValue, 'cellar.history'), lodash.get(oldValue, 'cellar.history'))){
						_showHistory();
					}
				}
			}, true);

			return true;
		}

		/**
		 * Updates history which is generated when showing a wine and/or editing in dialogs.
		 *
		 * @private
		 */
		function _showHistory(){

			$log.debug('Showing history...');

			self.combinedHistory = self.wine.getCombinedHistory();

			self.drinkHistory = self.wine.getDrinkHistory();
		}

		/**
		 * In order to allow next/prev functionality we need to know the index of the wine in relation to the current list.
		 */
		function updateWineIndex(){
			self.wineIndex = lodash.findIndex(WineTable.filteredWines, {"_id": self.params.id });
			$log.debug('Finding index from ' + WineTable.filteredTotal() + ' wines in list.', self.params.id, self.wineIndex);
		}

		function hasPrev(){
			return self.wineIndex > -1 && self.wineIndex > 0;
		}

		function hasNext(){
			return self.wineIndex > -1 && self.wineIndex + 1 < WineTable.filteredTotal();
		}

		function nextWine(){
			goToWineByIndex(self.wineIndex + 1, self.selectedTab);
		}

		function prevWine(){
			goToWineByIndex(self.wineIndex - 1, self.selectedTab);
		}

		function goToWineByIndex(index, tabIndex){
			var wine = WineTable.filteredWines[index];
			if (wine){
				var wineId = lodash.get(wine, '_id');
				return Utils.go('wines/edit', {id: wineId, tab: tabIndex});
			}
			$log.debug('Wine not found by index', index);
		}

		function grapeWasSelected(){
			self.grapeSelected = null;
			self.grapeQuery = null;
		}

		function grapeSearch(query){
			if (lodash.isNotEmptyOrNull(query)){

				var items = lodash.map(self.grapes, function(obj){
					return lodash.pick(obj, ['name', 'category']);
				});

                return filterCollection(query, items);
			}

			return self.grapes;
		}

		function nameSearch(query){
            return querySearch(self.wineNames, query, null);
		}

        function producerSearch(query){
            return lodash.isNotEmptyOrNull(query) ? filterCollection(query, self.producerNames) : self.producerNames;
        }

        function regionSearch(query){
            return lodash.isNotEmptyOrNull(query) ? filterCollection(query, self.regionData) : self.regionData;
		}

        function varietalSearch(query){
            return lodash.isNotEmptyOrNull(query) ? filterCollection(query, self.varietals) : self.varietals;
        }

        function distinctionSearch(query){
            return querySearch(self.distinctions, query, 'name');
        }

        function categorySearch(query){
            return querySearch(self.categories, query, 'name');
        }

        function bottleSizeSearch(query){
            if (lodash.isNotEmptyOrNull(query)){

                var items = lodash.map(self.bottleSizes, function(obj){
                    return lodash.pick(obj, ['name']);
                });

                return filterCollection(query, items);
            }

            return self.bottleSizes;
        }

		function showWine(){

			var wineId = lodash.get(self.wine, '_id', self.params.id);

			if (lodash.isEmptyOrNull(wineId))
			{
				$log.debug('No wine to show!');
				return false;
			}

			$log.debug('Showing wine', wineId);

			return userPouch.db().get(wineId, {conflicts: true})
					.then(function (wine) {
						$log.debug('got wine', wine);
						if ($state.is('wines/copy')) {

							var copy = angular.copy(wine);
							delete copy["_id"];
							delete copy["_rev"];
							delete copy["vintage"];
							lodash.set(copy, 'cellar.location', null);

							lodash.set(copy, 'cellar.id', null);

							// unset the history
							copy.cellar.history = [];

							lodash.set(copy, 'cellar.qty', 0);
							lodash.set(copy, 'cellar.totalValue', 0);

							self.wine = new Wine(copy);

							$log.debug('Copy', self.wine);

							$rootScope.layout.setPageTitle('Copy of ' + self.wine.getFullName());

						} else {
							self.wine = new Wine(wine);
							$rootScope.layout.setPageTitle(self.wine.getFullName());
						}

						_showHistory();

						if (lodash.get(wine, '_attachments')) {
							return userPouch.db().getAttachment(self.wine['_id'], 'thumbnail.jpg').then(function (blob) {
								self.thumbnail = URL.createObjectURL(blob);
								return self.wine;
							}).catch(function (err) {
								$log.error('Error getting thumb', err);
							});
						}

						return self.wine;
					})
					.then(function(wine){
						return _writeBarcode(false, false);
					})
					.then(generateId)
					.then(function(){
						self.original = angular.copy(self.wine);
						return true;
					})
					.then(_addCustomFields)
					.then(registerWatchers)
					.then(function(){
						// set distinction search
						$timeout(function(){
							self.search.distinction = lodash.get(self.wine, 'distinction.name');
						}, 1000);
					})
					.catch(function(err){
						$log.error('Error showing wine: ' + wineId, err);
					});
		}

		function closeBottomSheet(){
			$mdBottomSheet.hide();
		}

		function showError(error){
			$log.error(error);
            toast('Please correct your form errors.');
			self.error = error;
			showBottomSheetError();
		}

        function getFormErrors(){
            var errors = [];

            $log.debug($scope.form.$error);

            for (var key in $scope.form.$error) {
                for (var index = 0; index < $scope.form.$error[key].length; index++) {
                	var field = $scope.form.$error[key][index];
                	var fieldName = Utils.camelCaseToWords(lodash.get(field, '$$attr.ariaLabel', lodash.get(field, '$name')));

                	if (key == 'require-match') {
                        errors.push(fieldName + ' must be one of the built in options');
                    } else if (key == 'maxlength'){
						errors.push(fieldName + ' must be less than or equal to ' + lodash.get(field, '$$attr.maxlength') + ' characters.');
					}
					else {
                        errors.push(fieldName + ' is ' + key);
					}
                }
            }

            return 'You have the following form errors: ' + errors.join(', ') + '.';
        }

        function showBottomSheetError(){
            $mdBottomSheet.show({
                preserveScope: true,
                scope: $scope,
                templateUrl: 'templates/bottom-sheet-error.html'
            });
        }

		function openFooterActions($event){
			$mdBottomSheet.show({
				targetEvent: $event,
				preserveScope: true,
				scope: $scope,
				templateUrl: 'templates/crud/wines-edit-nav.html'
			});
		}

		function bodyInputSearch(query) {
			var results = query ? self.bodyInput.options.filter( createFilterFor(query, 'value') ) : self.bodyInput.options;
			return results;
		}

		function onChange(response){
			if (response.direction == 'pull' && response.change.docs.length){
				lodash.forEach(response.change.docs, function(newDoc, key) {
					if (newDoc._id === self.wine._id){
						$log.debug('Change is to the currently opened document!');
						// @TODO compare the two and prompt a merge?
						lodash.forEach(self.wine, function(n, key) {
							if (! lodash.isFunction(n) && self.original[key] === n){
								$log.debug("Key wasn't changed. Updating with latest.", key);
								// for now just update the untouched fields so save should go through even if user has a prior revision
								self.wine[key] = newDoc[key];
							}
						});
					}
				});
			}
			$log.debug('Wine Edit Change', response);
		}

		function resize(image){

			/**
			 * @TODO turn into service
			 */

			var deferred = $q.defer();

			var reader = new FileReader();

			reader.onloadend = function() {

				var tempImg = new Image();
				tempImg.src = reader.result;
				tempImg.onload = function() {

					var MAX_WIDTH = 250;
					var MAX_HEIGHT = 250;
					var tempW = tempImg.width;
					var tempH = tempImg.height;
					if (tempW > tempH) {
						if (tempW > MAX_WIDTH) {
							tempH *= MAX_WIDTH / tempW;
							tempW = MAX_WIDTH;
						}
					} else {
						if (tempH > MAX_HEIGHT) {
							tempW *= MAX_HEIGHT / tempH;
							tempH = MAX_HEIGHT;
						}
					}

					var canvas = document.createElement('canvas');
					canvas.width = tempW;
					canvas.height = tempH;
					var ctx = canvas.getContext("2d");
					ctx.drawImage(this, 0, 0, tempW, tempH);

					$window.pica.resizeCanvas(canvas, canvas, {
						quality: 3,
						unsharpAmount: 50,
						unsharpThreshold: 10,
						transferable: true
					}, function (err) {

						var dataUrl = canvas.toDataURL("image/jpeg", 0.7);

						deferred.resolve(dataUrl);
					});

				};
			};

			reader.readAsDataURL(image);

			return deferred.promise;
		}

		function uploadImage(dataUrl) {

			$log.debug('Uploading', dataUrl);

			// dataUrl looks like data:image/png;base64,iVBORw
			var data = dataUrl.substr(dataUrl.indexOf(',') + 1);

			userPouch.db().putAttachment(self.wine['_id'], 'thumbnail.jpg', self.wine['_rev'], data, 'image/jpg').then(function () {
				return userPouch.db().getAttachment(self.wine['_id'], 'thumbnail.jpg');
			}).then(function (blob) {
				self.thumbnail = URL.createObjectURL(blob);
			});
		}

		function resizeAndUploadImage(file){
			if (lodash.isObject(file)){
				$log.debug('resizeAndUploadImage', file);
				resize(file).then(function(dataUrl){
					$log.debug('dataUrl', dataUrl);
					uploadImage(dataUrl);
				});
			}
		}

		function nameChange(){
			var wineName = lodash.get(self.wine, 'name');

			// try to set varietal on name alone
			if (lodash.isNotEmptyOrNull(wineName)) {
				// try to select varietal automatically
				var matchingVarietal = lodash.find(self.varietals, {"name": wineName});

				if (matchingVarietal) {
					self.wine.varietal = lodash.pick(matchingVarietal, ['_id', 'name']);

					return true;
				}
			}

			return false;
		}

		function varietalChange(){

			$log.debug('Varietal was changed. Handling...', self.wine.distinction);

			var varietalName = lodash.get(self.wine, 'varietal.name');

			if (lodash.isNotEmptyOrNull(varietalName)){
				// try to select distinction automatically
				var matchingDistinction = lodash.find(self.distinctions, {"name": varietalName});

				if (matchingDistinction){
					// update distinction to only include the data we need since full distinction data is stored on PWC db
					self.wine.distinction = matchingDistinction;
				}
			}

			return false;
		}

		function distinctionChange(overwrite){

			var distinctionName = lodash.get(self.wine, 'distinction.name');

			if (lodash.isEmptyOrNull(distinctionName)){
				return false;
			}

			var category = lodash.get(self.wine, 'distinction.category');

			var body = lodash.get(self.wine, 'distinction.body');

			if (overwrite || lodash.isEmptyOrNull(category)){
				lodash.set(self.wine, 'category', lodash.findWhere(self.categories, {"code": category}));
			}

			if (overwrite || lodash.isEmptyOrNull(body)){
				lodash.set(self.wine, 'body', body);
			}

			// update distinction to only include the data we need since full distinction data is stored on PWC db
			self.wine.distinction = lodash.pick(self.wine.distinction, ['_id', 'legacyId', 'name', 'body']);

			$log.debug('Distinction was changed. Handling...', self.wine.distinction);
		}

		function updateTotalValue(){
			self.wine.cellar.totalValue = parseInt(self.wine.cellar.qty) * self.wine.cellar['value'];

			if (self.wine.cellar.qty > 0){
				self.wine.cellar.tasted = false;
				self.wine.cellar.wished = false;
			}
		}

		function markAllOnOrderAsArrived(){
			WineRepository.markAllOnOrderAsArrived(self.wine)
				.then(function(){
					$rootScope.$emit('WineRecordWasChanged');
					toast('All orders for wine marked arrived.');
				});
		}

		function toast(message){

			return $mdToast.show(
				$mdToast.simple()
					.content(message)
					.position('top right')
					.hideDelay(5000)
			);
		}

		function uploadDoc(file){
            return userPouch.getActiveUser().then(function(user){

                $log.debug('Uploading doc...');

                if (! lodash.get(self.wine, '_id')){
                	// when adding a new wine, we don't yet have an id, generate here so we can upload
                	self.wine._id = self.wine.generateId();
				}

                return API.saveFile(lodash.get(user, 'name'), lodash.get(user, 'derived_key'), file, self.wine._id);
            });
		}

		function save(returnToList, refresh, redirectRoute, redirectParams) {

            closeBottomSheet();

			if (! $scope.form.$valid) {
                showError(getFormErrors());
				return false;
			}

			self.error = null;

			// need to cleanup the category object if the name is empty

			// first see if wine exists by id, don't want user to save the same record

			if (! lodash.get(self.wine, '_id')){
				// new or copied wine, need to ensure id is unique
				var id = self.wine.generateId();

				$log.debug('Checking to see if wine exists with id: ', id);

				return WineRepository.get(id)
					.then(function(data){
						showError('You cannot add a wine that already exists. Please adjust producer, name, region, varietal, vineyard and/or vintage.');
						return false;
					})
					.catch(function(e){
						// does not exist ok to save
						$log.debug('Ok to save');
						return processSave(returnToList, refresh, redirectRoute, redirectParams);
					});
			} else {
				return processSave(returnToList, refresh, redirectRoute, redirectParams);
			}

			return false;
		}

		function processSave(returnToList, refresh, redirectRoute, redirectParams){
			if (lodash.has(self.wine, 'category.name') && lodash.isEmpty(self.wine.category.name)){
				self.wine.category = null;
			}

			// don't set custom fields to null
			if (self.wine.custom && self.wine.custom.length > 0){
				self.wine.custom = lodash.reject(self.wine.custom, function(item) {
					return lodash.isEmptyOrNull(item['value']);
				});
			}

            if ($scope.form.doc.$valid && self.doc) {
                $log.debug('Got doc', self.doc);

                return uploadDoc(self.doc).then(function(resp) {
                    $log.debug(resp);
                    // update wine doc before save
					return self.wine.addDoc(resp.data.file);
                })
				.then(function(){
                    return saveWine(returnToList, refresh, redirectRoute, redirectParams);
				})
				.catch(function(resp){
                    Rollbar.Rollbar.error(resp);
                    $log.error('Error uploading file.', resp);
                    showError(lodash.get(resp, 'data.error'));
                });
            }

            return saveWine(returnToList, refresh, redirectRoute, redirectParams);
		}

		function saveWine(returnToList, refresh, redirectRoute, redirectParams)
		{
            return WineRepository.save(self.wine)
                .then(function(){
                    // update original so save prompt won't fire
                    $timeout(function(){
                        // need to trigger digest
                        self.original = angular.copy(self.wine);
                        UserStore.state.hasPendingChanges = false;
                        $scope.form.$setPristine();

                        // unset active upload
                        self.doc = null;

                    }).then(function(){

                        self.toast('Record saved!');
                        $log.debug('Record saved');

                        if (lodash.isNotEmptyOrNull(redirectRoute)){
                            return Utils.go(redirectRoute, redirectParams);
                        }

                        if (returnToList){
                            return $state.transitionTo('wines');
                        }

                        if (angular.isDefined(refresh)){
                            return Utils.go('wines/edit', {id: self.wine._id});
                        }

                        return showWine();
                    });
                })
                .catch(function(err){
                    Rollbar.Rollbar.error(err);
                    $log.error('Error saving wine via Repository', err, self.wine);
                });
		}

		function toggleFavorite(){
			self.wine.cellar.starred = (! self.wine.cellar.starred);
			save();
		}

		function canRemove() {
			return ! lodash.isEmpty(self.wine['_id']);
		}

		function revert(){
			self.wine = self.original;

            closeBottomSheet();
		}

		function confirmRemoveHistory(event, combinedHistoryIndex){
			var confirm = $mdDialog.confirm()
				.title('Are you sure?')
				.content('This will PERMANENTLY delete this wine history item.')
				.ariaLabel('Confirm Deletion')
				.ok('Yes, delete the record!')
				.cancel('No')
				.targetEvent(event);

			$mdDialog.show(confirm).then(function() {
				removeHistory(combinedHistoryIndex);
			}, function() {
				// decided not to
			});
		}

		function removeHistory(combinedHistoryIndex){

			lodash.pullAt(self.combinedHistory, combinedHistoryIndex);

			lodash.set(self.wine, 'cellar.history', self.combinedHistory);

			// need to ensure cellar totals are correct
			self.wine.updateCellar();
		}

		function confirmDelete(ev) {
			var confirm = $mdDialog.confirm()
				.title('Are you sure?')
				.content('This will PERMANENTLY delete this wine record.')
				.ariaLabel('Confirm Deletion')
				.ok('Yes, delete the record!')
				.cancel('No')
				.targetEvent(ev);

			$mdDialog.show(confirm).then(function() {
				 userPouch.remove(self.wine, function(err, response){
                     closeBottomSheet();
					if (err) {
						$log.debug('wine', self.wine);
						$log.debug('err deleting', response);
					} else {
						self.toast('Record deleted!');
					}
					Utils.go('wines');
				});
			}, function() {
				// decided not to
			});
		}

		function openAgingPotential(ev) {

			var incomplete = [];

			if (! lodash.get(self.wine, 'vintage')){
				incomplete.push('<li>Vintage</li>');
			}

			if (! lodash.get(self.wine, 'distinction.name')){
				incomplete.push('<li>Distinction</li>');
			}

			if (! lodash.get(self.wine, 'region.name')){
				incomplete.push('<li>Region / Appellation</li>');
			}

			if (incomplete.length > 0){

				return $mdDialog.show(
					$mdDialog.alert()
						.title('Missing Information')
						.htmlContent('Please set the following missing fields in order to lookup maturity dates:<br /><ul>' + incomplete.join(', ') + '</ul>')
						.ariaLabel('Missing Required Information')
						.ok('Got it!')
						.targetEvent(ev)
				);
			}

			new AgingPotential(self.wine).then(function(data){

				$mdDialog.show({
					controller: 'WineAgingController as dialog',
					locals: {
						wine: self.wine,
						wineAgingPotential: data
					},
					templateUrl: 'templates/dialogs/aging-potential.html',
					targetEvent: ev
				});

			});
		}

		/**
		 * This takes a string from input and converts to our chip format.
		 * @param chip
		 * @returns {{name: *, type: null}}
		 */
		function convertToGrape(chip){

			if (lodash.isObject(chip)){
				return chip;
			}

			return {
				name: chip,
				pct: null,
				category: null
			};
		}

		function purchase(transaction, combinedHistoryIndex){
			return DialogService.purchase(self.wine, transaction, combinedHistoryIndex, false);
		}

		function drink(transaction, combinedHistoryIndex){
			return DialogService.drink(self.wine, transaction, combinedHistoryIndex, false);
		}

		function sale(transaction, combinedHistoryIndex){
			return DialogService.sale(self.wine, transaction, combinedHistoryIndex, false);
		}

		function gift(transaction, combinedHistoryIndex){
			DialogService.gift(self.wine, transaction, combinedHistoryIndex, false);
		}

		function loss(transaction, combinedHistoryIndex){
			DialogService.loss(self.wine, transaction, combinedHistoryIndex, false);
		}

		/**
		 * Triggers an overlay to walk user through what subtraction item they want to do.
		 * @param transaction
		 * @param combinedHistoryIndex
		 */
		function subtract(){
			return DialogService.subtract(self.wine, false);
		}

		function showAlert(content) {
			return $mdDialog.show(
				$mdDialog.alert({
					"title": "Oops",
					"content": content,
					"ok": "Got it!"
				})
			);
		}

		function searchWineSearcher(){
			var vintage = (self.wine.vintage) ? self.wine.vintage : 'NV';

			var keywords = self.wine.getFullName().toLowerCase();

			// replace non-alphanumeric and multiple spaces with one space
			keywords = keywords.replace(/\W+/g, " ") ;

			// build url, see http://www.wine-searcher.com/wine-link.lml
			var url = 'http://www.wine-searcher.com/find/' + encodeURIComponent(keywords) + '/' + vintage + '/-/-/a';

			openExternalLink(url, 'inappbrowser', true);
		}

		function openExternalLink(url, type, showLocationBar){
			switch(type){
				// Loads in the system browser
				case 'system':
					type = '_system';
					break;

				// Loads in the current window / cordova web-view
				case 'self':
					type = '_self';
					break;

				// Loads in the InAppBrowser
				default:
				case 'inappbrowser':
					type = '_blank';
					break;
			}


			// default to no location bar
			var locationBar = 'location=no';

			if (showLocationBar){
				locationBar = '';
			}

			$window.open(url, type, locationBar);
		}

        /**
         * Create filter function for a query string
         */
        function filterCollection(query, collection) {

            var words = lodash.words(query);

            var filtered = collection;

            lodash.each(words, function(word) {
                filtered = $filter('filter')(filtered, word);
            });

            return filtered;
        }

		function querySearch(collection, query, itemProp) {

			var results = lodash.isNotEmptyOrNull(collection) && query && query.length > 0 ? collection.filter(createFilterFor(query, itemProp)) : collection;

			return results;
		}

		function createFilterFor(query, itemProp) {

			var needle = lodash.words(angular.$$lowercase(query)).join(' ');

			return function filterFn(item) {
				var haystack = angular.$$lowercase(itemProp ? item[itemProp] : item);
                var silencedDiacritics = $filter('diacriticsFilterFunction')(haystack);
				return lodash.contains(haystack, needle) ||
                    lodash.contains(haystack.replace(/-/g, ' '), needle) ||
					lodash.contains(silencedDiacritics, needle) ||
                    lodash.contains(silencedDiacritics.replace(/-/g, ' '), needle);
			};
		}

		function submitForm(returnToList, refresh){

			if (! $scope.form.$valid){

				return false;
			}

			save(returnToList, refresh);
		}

		/**
		 * NOTE: Workaround
		 * 	Need to focus the input field for grape % inside.
		 * 	Currently when you select a chip Angular Material Design focuses the chip and you can't enter an
		 * 	input that is in the chip template.
		 */
		function selectChip($event){
			var $el = angular.element($event.currentTarget);
			var $inputs = $el.find('input');
			if ($inputs.length){
				$timeout(function(){
					$inputs[0].focus();
				}, 100);
			}
		}

		function generateId(){
			if (lodash.isEmptyOrNull(self.wine.cellar.id)){
				return WineRepository.generateNumericId().then(function(id){
					self.wine.cellar.id = id;
					return true;
				}).catch(function(e){
					$log.error('Error generating id.', e);
				});
			}
		}

		/**
		 * This is used on a button to signify the user wants to generate a barcode.
		 * @returns {*}
		 */
		function generateBarcode(){
			return _writeBarcode(true, true);
		}

		function _writeBarcode(force, showToast){

			var forcedByUser = angular.isDefined(force) ? force : false;

			var shouldShowToast = angular.isDefined(showToast) ? showToast : false;

			$log.debug('Writing barcode...', force, showToast);

			// set the barcode if empty

			var currentBarcode = lodash.get(self.wine, 'cellar.ids.barcode');

			if (lodash.isEmptyOrNull(currentBarcode)){
				if (! forcedByUser){ return null; }
				$log.debug('Setting barcode id on forced generation.');
				var generatedBarcode = WineRepository.generateBarcode(self.wine.cellar.id);
				lodash.set(self.wine, 'cellar.ids.barcode', WineRepository.generateBarcode(self.wine.cellar.id));
				currentBarcode = generatedBarcode;
			}

			if (currentBarcode.length < 11){
				return toast("Barcode error: must be 11 or 12 digits.");
			}

			$log.debug('Generating barcode from:', currentBarcode);

			return new BarcodeFactory(currentBarcode)
				.then(function(barcode){
					// update the model in case check sum wasn't sent from model data (Barcode Service calculates it if necessary)
					lodash.set(self.wine, 'cellar.ids.barcode', barcode);

					if (forcedByUser){
						// mark as generated by user
						lodash.set(self.wine, 'cellar.ids.barcodeGen', true);
					}

					if (shouldShowToast){
						return toast("Barcode generated. Don't forget to save when done editing.");
					}
				})
				.catch(function(e){
					// clear any prior canvas barcode
					var canvas = document.getElementById("canvas");
					var ctx = canvas.getContext("2d");
					ctx.clearRect(0, 0, canvas.width, canvas.height);

					if (shouldShowToast){
						return toast("Barcode error: " + e);
					}
					$log.error('Error writing barcode', e);
				});
		}

		function chooseLabel(){
			$mdDialog.show({
				templateUrl: 'templates/dialogs/print-label.html',
				controller: 'PrintLabelDialogController as dialog',
				locals: {
					wine: self.wine
				}
			});
		}

		function editTransaction(event, index){

			$log.debug('Editing transaction', event.type);

			switch (event.type){
				case 'purchase':
					purchase(event, index);
				break;

				case 'drink':
					drink(event, index);
				break;

				case 'sale':
					sale(event, index);
				break;

				case 'gift':
					gift(event, index);
				break;

				case 'loss':
					loss(event, index);
				break;
			}
		}

		function duplicate(){
			$log.debug('Sending user to duplicate wine', lodash.get(self.wine, '_id'));
			return Utils.go('wines/copy', {id: lodash.get(self.wine, '_id')});
		}

		function _addCustomFields(){

			UserService.getSetting('customFields').then(function(customFields){

				$log.debug('User Setting: customFields', customFields);

				if (lodash.isEmptyOrNull(self.wine.custom)){
					self.wine.custom = [];
				}

				lodash.forEach(customFields, function(customField){
					var exists = lodash.findWhere(self.wine.custom, { "label": customField });
					if (! exists){
						self.wine.custom.push({
							"label": customField,
							"value": null
						});
					}
				});
			});
		}

		function shouldShowField(fieldName){
			if (lodash.isNull(self.fields)){
				// haven't gotten the user's enabled/disabled fields yet
				return false;
			}
			return lodash.get(self.fields, fieldName, true);
		}

        /**
		 * Will make a request to API to get signed file url.
         * @param fileName
         */
		function openDoc(fileName){

            var popup = $window.open('', 'file', '');

            popup.document.write('Loading your document...');

            return userPouch.getActiveUser().then(function(user){
                return API.getFileUrl(lodash.get(user, 'name'), lodash.get(user, 'derived_key'), fileName, self.wine._id);
            }).then(function(response){
            	$log.debug(response);
                return response.data.url;
			}).then(function(url){
                popup.location.href = url;
			});
        }

        function removeDoc(fileName){
			self.wine.docs = lodash.pull(self.wine.docs, fileName);
			UserStore.state.hasPendingChanges = true;
		}

		function _loadWineNames(){
            WineRepository.uniqueWineNames()
                .then(function(wineNames){
                    self.wineNames = wineNames;
                    return true;
                });
		}

		function _loadProducerNames(){
            WineRepository.uniqueProducers()
                .then(function(producers){
                    $log.debug('Setting User Producers...');
                    self.producerNames = producers;
                    return producers;
                }).then(function(producers){
                	$log.debug('Getting Producers from PWC db...');
					return systemPouch.fetch('producer').then(function(data){
						var combined = producers.concat(lodash.map(data, 'name'));
						self.producerNames = lodash.uniq(combined.sort());
					}).catch(function(err){
						$log.error(err);
					});
				}).catch(function(err){
					$log.error(err);
				});
		}

		function _loadRegionData(){

            $log.debug('Adding PWC Regions...');

            PwcRepository.regions()
				.then(function(pwcRegions){

                    self.regionData = pwcRegions;

                    $log.debug('Adding User Regions...');

                    return WineRepository.uniqueRegions()
							.then(function(userRegions){
                                return pwcRegions.concat(userRegions);
							});
            	})
				.then(function(combined){
					// Remove dupes by name and sort. PWC regions will take pref since they came first
                    var final = lodash.uniq(combined, function(obj) {
                        return obj.name;
                    });

                    self.regionData = lodash.sortBy(final, 'name');

                    return true;
				})
				.catch(function(err){
                	$log.error('Error loading region data', err);
					Rollbar.Rollbar.error(err);
            	});
		}

		function selectedRegion(item){
			if (lodash.isNotEmptyOrNull(item)){
                $log.debug('User chose a region', item);
                lodash.set(self.wine, 'region', angular.copy(item));
			}
		}

        function selectedDistinction(item){
            if (lodash.isNotEmptyOrNull(item)) {
                $log.debug('User chose a distinction', item);
                lodash.set(self.wine, 'distinction', lodash.pick(item, ['_id', 'name', 'legacyId', 'body', 'category']));
                // mark valid
                $scope.form.wineDistinction.$setValidity("require-match", true);
            }
        }

        function selectedType(item){
            if (lodash.isNotEmptyOrNull(item)) {
                $log.debug('User chose a type', item);
                lodash.set(self.wine, 'category', lodash.omit(item, ['_rev', 'type']));
            }
        }

        /**
         * Runs when user is typing a region name. In case the user chooses a region but then starts typing, we need to
         * reset it to only include the name, otherwise we'll end up with a region name that belongs to the wrong parent region.
         * @param regionName
         */
        function cleanRegion(regionName){
            if (lodash.get($scope, 'form.wineRegionName.$dirty')){
            	// get only the region name so we can reset it
                var obj = lodash.pick(self.wine.region, 'name');
				$log.debug('Cleaning up the region:', obj, regionName);
				lodash.set(self.wine, 'region', obj);
            }
        }

        /**
		 * Formats grape record for output to autocomplete.
         * @param item
         * @returns {string}
         */
        function grapeText(item){
            return item.name + ' - ' + item.category;
		}

        /**
		 * Check the distinction field when it changes and mark it as invalid if the user hasn't chosen one of our distinctions.
		 * We don't use md-require-match because it will fail if distinction object isn't exact.
         */
		function validateDistinction(){

			if (! lodash.get($scope, 'form.wineDistinction.$dirty')){
				return true;
			}

            $log.debug('Validating distinction...', $scope.form.wineDistinction);

			var inputVal = self.search.distinction;

			var distinctionName = lodash.get(self.wine, 'distinction.name');

			if (inputVal != distinctionName){
                $log.debug('Resetting distinction...');
                // reset the distinction because the user is searching
                self.wine.distinction = {name: null};
			}

            // field is invalid if input has a length and wine.distinction._id is empty
			if (lodash.isNotEmptyOrNull(inputVal) && ! lodash.get(self.wine, 'distinction._id')){
				$log.warn('Invalid distinction...');
                $scope.form.wineDistinction.$setValidity("require-match", false);
			} else {
                $scope.form.wineDistinction.$setValidity("require-match", true);
			}
		}
	}

})();
